import { ZodError } from 'zod'

export type DeepPartial<T> = T extends object ? { [P in keyof T]?: DeepPartial<T[P]> } : T

export const isZodError = (err: unknown): err is ZodError => {
  return Boolean(err && (err instanceof ZodError || (err as ZodError).name === 'ZodError'))
}

type Entries<T> = {
  [K in keyof T]: [K, T[K]]
}[keyof T][]

// type Object.entries
export function entriesFromObject<T extends object>(object: T): Entries<T> {
  return Object.entries(object) as Entries<T>
}

// type Object.keys
export function keysFromObject<T extends object>(object: T): (keyof T)[] {
  return Object.keys(object) as (keyof T)[]
}
